import house1 from "./media/image1.png";
import house2 from "./media/image2.png";
import house3 from "./media/image3.png";

export const properties = [
  {
    id: "1",
    img: house1,
    price: "35000",
    address: "8502 Preston Rd. Inglewood, Maine 98280",
    bedrooms: 2,
    bathrooms: 2,
    space: 2000,
    type: "House",
    status: "For Sale",
    description: "Beautiful family home with modern finishes, large backyard, and close to schools and shopping centers.",
  },
  {
    id: "2",
    img: house2,
    price: "38000",
    address: "Wailuku, HI 96793",
    bedrooms: 3,
    bathrooms: 2,
    space: 2300,
    type: "Villa",
    status: "For Sale",
    description: "Stunning villa with ocean views, open floor plan, and premium appliances throughout.",
  },
  {
    id: "3",
    img: house3,
    price: "47000",
    address: "2917 23rd St",
    bedrooms: 4,
    bathrooms: 3,
    space: 3000,
    type: "Estate",
    status: "For Sale",
    description: "Spacious estate property with pool, garden, and multiple living areas perfect for entertaining.",
  },
];

export const allProperties = [
  ...properties,
  {
    id: "4",
    img: house1,
    price: "42000",
    address: "123 Maple Ave, Springfield, IL 62701",
    bedrooms: 3,
    bathrooms: 2,
    space: 2200,
    type: "House",
    status: "For Rent",
    description: "Charming home with hardwood floors, updated kitchen, and a cozy fireplace.",
  },
  {
    id: "5",
    img: house2,
    price: "55000",
    address: "456 Oak Lane, Portland, OR 97201",
    bedrooms: 4,
    bathrooms: 3,
    space: 3200,
    type: "Luxury",
    status: "For Sale",
    description: "Luxurious property with smart home features, rooftop terrace, and city views.",
  },
  {
    id: "6",
    img: house3,
    price: "28000",
    address: "789 Pine St, Austin, TX 73301",
    bedrooms: 2,
    bathrooms: 1,
    space: 1500,
    type: "Apartment",
    status: "For Rent",
    description: "Modern downtown apartment with gym access, parking, and concierge service.",
  },
  {
    id: "7",
    img: house1,
    price: "62000",
    address: "321 Birch Rd, Denver, CO 80201",
    bedrooms: 5,
    bathrooms: 4,
    space: 4000,
    type: "Estate",
    status: "For Sale",
    description: "Grand estate with mountain views, home theater, wine cellar, and resort-style pool.",
  },
  {
    id: "8",
    img: house2,
    price: "33000",
    address: "654 Cedar Ct, Miami, FL 33101",
    bedrooms: 2,
    bathrooms: 2,
    space: 1800,
    type: "Condo",
    status: "For Sale",
    description: "Beachfront condo with panoramic ocean views, modern design, and premium amenities.",
  },
  {
    id: "9",
    img: house3,
    price: "48000",
    address: "987 Elm St, Seattle, WA 98101",
    bedrooms: 3,
    bathrooms: 2,
    space: 2500,
    type: "House",
    status: "For Rent",
    description: "Modern home in quiet neighborhood with garden, deck, and energy-efficient features.",
  },
];

export const testimonials = [
  {
    id: "1",
    name: "Sarah Johnson",
    role: "Homeowner",
    text: "POSH made finding our dream home effortless. The team guided us through every step and we couldn't be happier with our new home.",
    rating: 5,
  },
  {
    id: "2",
    name: "Michael Chen",
    role: "Investor",
    text: "As a real estate investor, I've worked with many agencies. POSH stands out for their professionalism and deep market knowledge.",
    rating: 5,
  },
  {
    id: "3",
    name: "Emily Rodriguez",
    role: "First-time Buyer",
    text: "I was nervous about buying my first home, but the POSH team made it simple and stress-free. Highly recommended!",
    rating: 5,
  },
];

export const agents = [
  {
    id: "1",
    name: "David Wilson",
    role: "Senior Agent",
    phone: "(555) 123-4567",
    email: "david@posh.com",
    sales: 150,
    image: "https://i.pravatar.cc/150?img=68",
  },
  {
    id: "2",
    name: "Jessica Lee",
    role: "Property Specialist",
    phone: "(555) 234-5678",
    email: "jessica@posh.com",
    sales: 120,
    image: "https://i.pravatar.cc/150?img=47",
  },
  {
    id: "3",
    name: "Robert Martinez",
    role: "Luxury Agent",
    phone: "(555) 345-6789",
    email: "robert@posh.com",
    sales: 98,
    image: "https://i.pravatar.cc/150?img=70",
  },
  {
    id: "4",
    name: "Amanda Taylor",
    role: "Rental Specialist",
    phone: "(555) 456-7890",
    email: "amanda@posh.com",
    sales: 85,
    image: "https://i.pravatar.cc/150?img=45",
  },
];
